import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { GenerateReport } from 'Common/ObjectHelper';
import { errorToast } from 'Common/ToastHelper';
import * as ReportActions from 'State/report/actions';
import * as ReportSelectors from 'State/report/selectors';

const withReportSubscription = Component => {
  class WithReport extends React.Component {
    componentDidUpdate(prevProps) {
      const { clearReport, resetReportError } = this.props;
      GenerateReport(
        this.props,
        prevProps,
        'Report',
        'reportData',
        clearReport
      );
      errorToast(this.props, prevProps, 'reportError', resetReportError);
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  const mapStateToProps = state => ({
    reportData: ReportSelectors.getReportData(state),
    reportError: ReportSelectors.getReportError(state),
    reportFetching: ReportSelectors.getReportFetching(state),
  });

  const mapDispatchToProps = {
    resetReportError: ReportActions.resetError,
    getReport: ReportActions.getReport,
    getExcelFile: ReportActions.getExcelFile,
    clearReport: ReportActions.clearReport,
    submit,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithReport);
};

export { withReportSubscription };



// WEBPACK FOOTER //
// ./src/state/report/withReportSubscription.js